import { DatabaseEntities } from './base';
import { Nullable } from './globals';

export enum UnitType {
  Appointment = 'Appointment',
  Units = 'Units'
}

export enum UnitGrouper {
  LoadType = DatabaseEntities.LoadType,
  Dock = DatabaseEntities.Dock,
  Warehouse = DatabaseEntities.Warehouse,
  LoadTypeGroup = DatabaseEntities.LoadTypeGroup
}

/**
 * Constants for converting Luxon weekday values (1-7, where 1 = Monday, 7 = Sunday)
 * to array indices (0-6, where 0 = Sunday, 6 = Saturday)
 */
export const LUXON_WEEKDAY_SUNDAY = 7;
export const ARRAY_INDEX_SUNDAY = 0;

/**
 * Converts Luxon weekday (1-7, Mon-Sun) to array index (0-6, Sun-Sat)
 * @param luxonWeekday - Luxon weekday value (1 = Monday, 7 = Sunday)
 * @returns Array index (0 = Sunday, 6 = Saturday)
 */
export function luxonWeekdayToArrayIndex(luxonWeekday: number): number {
  return luxonWeekday === LUXON_WEEKDAY_SUNDAY ? ARRAY_INDEX_SUNDAY : luxonWeekday;
}

export interface IUnitLimit {
  loadTypes: string[] | null | undefined;

  // general liimits
  dailyLimit: Nullable<number>;
  weeklyLimit: Nullable<number>;
  monthlyLimit: Nullable<number>;

  // specific weekdays limits
  mondayLimit: Nullable<number>;
  tuesdayLimit: Nullable<number>;
  wednesdayLimit: Nullable<number>;
  thursdayLimit: Nullable<number>;
  fridayLimit: Nullable<number>;
  saturdayLimit: Nullable<number>;
  sundayLimit: Nullable<number>;

  // specific months limits
  januaryLimit: Nullable<number>;
  februaryLimit: Nullable<number>;
  marchLimit: Nullable<number>;
  aprilLimit: Nullable<number>;
  mayLimit: Nullable<number>;
  juneLimit: Nullable<number>;
  julyLimit: Nullable<number>;
  augustLimit: Nullable<number>;
  septemberLimit: Nullable<number>;
  octoberLimit: Nullable<number>;
  novemberLimit: Nullable<number>;
  decemberLimit: Nullable<number>;
}
